import { render } from "./NotFound.vue?vue&type=template&id=fbba54c0"
const script = {}
script.render = render

export default script